import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from "../utils/config";
import { OrderOperations } from '../enums/orderOperations';
import Order from '../models/order';
import { startLoading, stopLoading } from "./application";
import { cartApi } from './cart';
import {delete_cookie, get} from '../utils/cookies'
import { onErrorHandler } from "./handlers";
import Cart from '../models/cart';
import { newCartApi } from './newCart';
import { errorOperationNames } from '../enums/pccEnums';

import { processOrderDetails, massageLineItem } from "../utils/orders";
declare const window: any;

export const orderApi = createApi({
    reducerPath: 'orderApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_ORDERDETAILS ?? "https://npr-order.api.pens.com/",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
  }),
    tagTypes: ['Order'],
    endpoints: (builder) => ({
        getOrderById: builder.query({
          async queryFn({ orderId, cartId }, { dispatch, getState }, _extraOptions, baseQuery) {
            if (orderId) {
              const orderRes: any = await baseQuery({
                url: `v1/${orderId}?withLineItemState=true`,
                method: 'GET'
              });
              if(orderRes?.data){
                return { data: new Order(orderRes?.data)};
              }
              return orderRes;
            }  
            if(cartId){
              await dispatch(newCartApi.endpoints.markCartInvisible.initiate({cartId: cartId}));
              const cartObj:any = await dispatch(cartApi.endpoints.getInvisibleCart.initiate({cartId: cartId}));
              return {data: JSON.parse(JSON.stringify(cartObj.data))};
            }
            return {data: {}};
          },
          async onQueryStarted(args, { dispatch, getState, queryFulfilled }) {
            try{
                await queryFulfilled;
                delete_cookie('np.cartId');
                if (navigator.cookieEnabled) {
                  window.localStorage.removeItem("_appliedCoupon");
                  window.localStorage.removeItem("_gaActionField");
                  window.localStorage.removeItem("_productHistory");
                  window.localStorage.removeItem("cartAddress");
                }
                dispatch(stopLoading());
            }
            catch(error){
                console.log(error);
                dispatch(onErrorHandler({operation: OrderOperations.GET_ORDER_BY_ID, err: JSON.stringify(error), errMsg: 'Error: while fetching order details', api: `${window.Config.LAMBDA_ORDERDETAILS}v1/:orderId`}));
            }finally{
              dispatch(stopLoading());
            }
          },
        }),
        payLater: builder.mutation({
            query: (data) => ({
                url : window.Config.LAMBDA_PAYLATER,
                method: 'POST',
                body: data
            }),
            async onQueryStarted(obj, { dispatch, getState, queryFulfilled }) {
                try{
                    const {data} = await queryFulfilled;
                    dispatch(stopLoading());
                    return data;
                }
                catch(error){
                    dispatch(stopLoading());
                    throw error;
                } 
            },
        }),
        getOrderStatus: builder.query({
            query: (data) => ({
                url : `v1/cart/${data.cartId}/status`,
                method: 'GET'
            }),
            async onQueryStarted(obj, { dispatch, getState, queryFulfilled }) {
                try{
                    const {data} = await queryFulfilled;
                    return data;
                }
                catch(error){
                    console.log(error);
                } finally {
                    dispatch(stopLoading())
                }
            },
        }),
        getOrderHistory: builder.query({
          query: (data) => ({
              url : `ordersinfo/${data.customerId}`,
              method: 'GET'
          }),
          async onQueryStarted(obj, { dispatch, getState, queryFulfilled }) {
              try{
                  const {data} = await queryFulfilled;
                  return data;
              }
              catch(error){
                  console.log(error);
              } finally {
                  dispatch(stopLoading())
              }
          },
        }),
        updateCustomizationInfo: builder.mutation({
            async queryFn({finalOrderId, finalObj}, {dispatch, getState}, _extraOptions,  baseQuery) {
                const response:any = await baseQuery({ url: `v2/${finalOrderId}/updatecustomizationInfo`,
                    method: 'POST',
                    body: finalObj,
                });
                return response;
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data; 
                }
                catch (error) {
                    dispatch(onErrorHandler({operation: errorOperationNames.UPDATE_CUSTOMIZATION_INFO, err: JSON.stringify(error), errMsg: 'Error: while uploading customizationInfo', api: `${window.Config.LAMBDA_ORDERDETAILS}v2/:orderId/updatecustomizationInfo`}));     
                }
            }
        }),
    }),
})

export const {useGetOrderByIdQuery, usePayLaterMutation, useGetOrderStatusQuery, useGetOrderHistoryQuery, useUpdateCustomizationInfoMutation} = orderApi;